import React from "react";
import { useTranslation } from "react-i18next";

import { DiversPreviewData, SOCIAL_ICONS } from "./types";
import {
    RichFooter,
    FooterMainSection,
    FooterColumns,
    FooterColumn,
    FooterColumnTitle,
    FooterRestaurantName,
    FooterDescription,
    FooterLegalLink,
    FooterSocialIcons,
    FooterSocialIcon,
    FooterCopyrightBar,
} from "./styled";

type FooterSectionProps = {
    diversData?: DiversPreviewData | null;
    primaryColor: string;
};

export function FooterSection({
    diversData,
    primaryColor,
}: FooterSectionProps): JSX.Element {
    const { t } = useTranslation();

    return (
        <RichFooter>
            <FooterMainSection>
                <FooterColumns>
                    <FooterColumn>
                        {diversData?.nameVisible !== false && (
                            <FooterRestaurantName>
                                {diversData?.restaurantName ||
                                    "Restaurant"}
                            </FooterRestaurantName>
                        )}
                        {diversData?.descriptionVisible !== false &&
                            diversData?.restaurantDescription && (
                                <FooterDescription>
                                    {diversData.restaurantDescription}
                                </FooterDescription>
                            )}
                    </FooterColumn>
                    {diversData?.showLegalInfo !== false && (
                        <FooterColumn>
                            <FooterColumnTitle>
                                {t("Legal information")}
                            </FooterColumnTitle>
                            <FooterLegalLink>
                                {t("Legal notices")}
                            </FooterLegalLink>
                            <FooterLegalLink>
                                {t("Privacy policy")}
                            </FooterLegalLink>
                            <FooterLegalLink>
                                {t("Terms of sale")}
                            </FooterLegalLink>
                            <FooterLegalLink>
                                {t("Terms of use")}
                            </FooterLegalLink>
                        </FooterColumn>
                    )}
                    {(diversData?.socialChannels || []).some(
                        (ch) => ch.enabled
                    ) && (
                        <FooterColumn>
                            <FooterColumnTitle>
                                {t("Follow us")}
                            </FooterColumnTitle>
                            <FooterSocialIcons>
                                {(diversData?.socialChannels || [])
                                    .filter((ch) => ch.enabled)
                                    .map((ch) => (
                                        <FooterSocialIcon
                                            key={ch.key}
                                            accentColor={primaryColor}
                                        >
                                            <svg viewBox="0 0 24 24">
                                                <path
                                                    d={
                                                        SOCIAL_ICONS[
                                                            ch.key
                                                        ] || ""
                                                    }
                                                />
                                            </svg>
                                        </FooterSocialIcon>
                                    ))}
                            </FooterSocialIcons>
                        </FooterColumn>
                    )}
                </FooterColumns>
            </FooterMainSection>
            <FooterCopyrightBar primaryColor={primaryColor}>
                © {t("All rights reserved")} Softavera{" "}
                {new Date().getFullYear()} - V1.0.0 - www.softavera.com
            </FooterCopyrightBar>
        </RichFooter>
    );
}
